/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import uuid from 'uuid/v1';
import { PropTypes } from 'prop-types';
import slugify from '../../../../../../utils/slugify';
import { useAuth } from '../../../../../../utils/AuthProvider';
import { fieldValue, messagesRef, channelsRef, firebaseauth } from '../../../../../../firebase';


const ChatConfigModule = ({ setModalTitle }) => {
  const initialState = {
    name: '',
  };

  const [state, setState] = useState(initialState);
  const [channelCreated, setChannelCreated] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [copyText, setCopyText] = useState('Copy');
  const firebaseUser = firebaseauth.currentUser;

  const inputHandler = (e) => {
    const { value, name } = e.target;
    const newState = {
      ...state,
      [name]: value,
    };
    setState(newState);
  };

  const saveChannel = async () => {
    setIsLoading(true);
    const url = `pslife_open_room_${uuid()}`;
    const newChannel = {
      createdAt: fieldValue.serverTimestamp(),
      url,
      name: state.name,
      channelPrivacy: 'open',
    };

    if (firebaseUser) {
      const channel = messagesRef.doc(url).set(newChannel);
      const channelDev = channelsRef.doc(url).set(newChannel);
      return Promise.all([channel, channelDev]).then((res) => {
        setChannelCreated({ name: state.name, url });
        setIsLoading(false);
        setModalTitle('Channel created');
      }).catch(err => console.log(err));
    }
  };

  const handleCopy = () => {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(channelCreated.url);
      setCopyText('Copied');
    } else {
      setCopyText('Did not copy');
    }
  };

  return (
    <div className="bg-black text-white p-4">
      {!channelCreated
        ? (
          <div className="py-4">
            <label className="flex-col font-americaMonoRegular text-xs uppercase text-white w-full" htmlFor="channelName">
              Channel name
              <input className="mt-1 font-americaMonoRegular p-2 bg-white outline-none w-full rounded-full" onChange={inputHandler} name="name" type="text" value={state.name || ''} />
            </label>
            <button
              type="button"
              onClick={saveChannel}
              disabled={isLoading}
              className="font-americaMonoBold text-xs px-8 py-1 h-7 my-1 rounded-full uppercase bg-greyFilter flex items-center"
            >
              {!isLoading ? 'Create' : 'creating..'}
            </button>
          </div>
        )
        : (
          <div className="py-4">
            <p className="flex-col font-americaMonoRegular text-xs uppercase text-white w-full">
              <span className="mr-2">Name:</span>
              {channelCreated.name}
            </p>
            <div className="flex mb-0 justify-between w-full">
              <p className="font-americaMonoRegular text-xs uppercase text-white">
                Id:
                <span className="ml-2">{channelCreated.url}</span>
              </p>
              <button
                type="button"
                className={`${copyText === 'copied' ? 'bg-grey' : 'bg-greyFilter'} font-americaMonoBold p-1 text-xs rounded uppercase flex flex-row items-center cursor-pointer`}
                onClick={handleCopy}
              >
                {copyText}
              </button>
            </div>
          </div>
        )}
    </div>
  );
};

ChatConfigModule.propTypes = {

};
ChatConfigModule.defaultProps = {
};

export default ChatConfigModule;
